import React from 'react';

/*
 * A user's initials in a coloured disc, the hue derived from the username
 * so the same person always wears the same colour. Grey when suspended.
 */

export const initialsOf = (firstName?: string, lastName?: string, username = ''): string => {
  const parts = [firstName, lastName].filter((p): p is string => Boolean(p && p.trim()));
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  const bits = username.split(/[._\-\s]+/).filter(Boolean);
  if (bits.length >= 2) return (bits[0][0] + bits[1][0]).toUpperCase();
  return username.slice(0, 2).toUpperCase() || '?';
};

export const hueOf = (seed: string): number => {
  let h = 0;
  for (let i = 0; i < seed.length; i += 1) h = (h * 31 + seed.charCodeAt(i)) | 0;
  return Math.abs(h) % 360;
};

interface Props {
  username: string;
  firstName?: string;
  lastName?: string;
  enabled?: boolean;
  size?: 'sm' | 'md' | 'lg';
}

export const UserAvatar: React.FC<Props> = ({ username, firstName, lastName, enabled = true, size = 'sm' }) => (
  <span
    className={`user-avatar is-${size}${enabled ? '' : ' is-off'}`}
    style={enabled ? ({ '--avatar-hue': hueOf(username) } as React.CSSProperties) : undefined}
    aria-hidden="true"
  >
    {initialsOf(firstName, lastName, username)}
  </span>
);
